import { Deferred } from 'jquery';
import {
  LOG,
  NATIVE_APP_RE_ENTERED,
  NATIVE_FILE_SELECTED,
  NATIVE_GET_REFRESH_TOKEN_R,
  NATIVE_GO_BACK,
  NATIVE_GO_TO,
  NATIVE_INITIALIZE_R,
  NATIVE_INVALID_PERMISSION,
  WEBVIEW_APP_REVIEW,
  WEBVIEW_ENSURE_SCROLL_STATE,
  WEBVIEW_FILE_UPLOAD,
  WEBVIEW_GET_REFRESH_TOKEN,
  WEBVIEW_INITIALIZE,
  WEBVIEW_LOCATION_CHANGE,
  WEBVIEW_OPEN_EXTERNAL_LINK,
  WEBVIEW_SET_REFRESH_TOKEN,
  WEBVIEW_CLIPBOARD_WRITE
} from './messageTypes';
// import { checkSession, onPushToken } from '../data/account/accountsActions';
// import { checkSession } from '../data/auth/authActions';
import {b64toBlob, goBack, replaceUrl, showPermissionModal} from './helpers';
// import { goBack, replaceUrl, showPermissionModal } from './helpers';

class NativeAPI {
  isNative = false;
  refreshToken = null;
  store = null;
  nativeInfo = null;
  history = window.history;
  constructor() {
    window.addEventListener('message', this.handleMessage); // ios
    document.addEventListener('message', this.handleMessage); //android

    const readyDef = Deferred();
    this.readyPromise = readyDef.promise();
    this.ready = false;

    this[NATIVE_INITIALIZE_R] = ({ nativeInfo }) => {
      this.ready = true;
      this.nativeInfo = nativeInfo;
      window.nativeInfo = nativeInfo;
      readyDef.resolve();
    };
    let i = 0;
    const check = () => {
      i++;
      this.initialize();
      if (!this.ready && i < 20) {
        setTimeout(check, 200);
      }
    };
    check();
  }
  initialize = () => {
    this.postToNative({ type: WEBVIEW_INITIALIZE, locals: window.SAILS_LOCALS });
  };
  setStore = store => {
    this.store = store;
  };
  setNative(val) {
    this.isNative = !!val;
  }
  postToNative = data => {
    // must wait a second before sending first messages
    const post = () =>
      this.isNative && window && window.ReactNativeWebView
        ? window.ReactNativeWebView.postMessage(JSON.stringify(data))
        : window.postMessage(JSON.stringify(data), '*'); //

    if (!this.ready && data.type !== WEBVIEW_INITIALIZE) {
      this.readyPromise.then(post);
    } else {
      post();
    }
  };
  defineListener = (type, func) => {
    this[type] = func;
  };
  removeListener = type => {
    delete this[type];
  };
  handleMessage = raw => {
    if (!this.isNative) {
      return;
    }

    try {
      const { data } = raw;
      const jsonData = JSON.parse(data);
      if (jsonData) {
        const { type } = jsonData;
        if (typeof this[type] === 'function') {
          this[type](jsonData);
        } else {
          console.log('No handler, logging');
          console.log(data);
        }
      }
    } catch (e) {
      console.log('Unable to handle message', raw);
    }
  };

  [NATIVE_GO_TO] = ({ type, path }) => {
    replaceUrl(this.history, path);
  };
  [NATIVE_GO_BACK] = ({ type }) => {
    goBack(this.history);
  };
  [NATIVE_INVALID_PERMISSION] = ({ type, permission }) => {
    showPermissionModal(permission);
  };
  [NATIVE_APP_RE_ENTERED] = ({ type }) => {
    this.log('App re-entered!')
    // this.store.dispatch(checkSession());
  };

  log = message => {
    const e = new Error();
    const stack = e.stack.toString().split(/\r\n|\n/);
    const callingLine = stack && stack[2];
    const fullMessage = `${message} [${callingLine}]`;
    if (this.isNative) {
      this.postToNative({ type: 'LOG', fullMessage });
    } else {
      console.log(fullMessage);
    }
  };

  getImageFromNative = () => {
    if (!this.isNative) {
      return Deferred().reject();
    }
    const promiseObj = Deferred();
    this.defineListener(NATIVE_FILE_SELECTED, ({ type, file }) => {
      try {
        this.removeListener(NATIVE_FILE_SELECTED);

        const fileBlob = b64toBlob(file.base64, file.type);

        promiseObj.resolve(fileBlob);
      } catch (e) {
        this.postToNative({ type: LOG, data: e.message });
      }
    });
    this.postToNative({ type: WEBVIEW_FILE_UPLOAD });
    return promiseObj.promise();
  };

  setLocation = location => {
    this.postToNative({ type: WEBVIEW_LOCATION_CHANGE, location });
  };

  setRefreshToken = refreshToken => {
    if (!this.isNative) {
      this.refreshToken = refreshToken;
      window.localStorage.setItem('refreshToken', refreshToken);
    } else {
      this.postToNative({ type: WEBVIEW_SET_REFRESH_TOKEN, refreshToken });
    }
  };

  getRefreshToken = () => {
    if (!this.isNative) {
      const refreshToken = window.localStorage.getItem('refreshToken');
      return Deferred().resolve(refreshToken).promise();
    }

    const promiseObj = Deferred();
    this.defineListener(NATIVE_GET_REFRESH_TOKEN_R, ({ type, refreshToken }) => {
      try {
        this.removeListener(NATIVE_GET_REFRESH_TOKEN_R);
        promiseObj.resolve(refreshToken);
      } catch (e) {
        this.log(e);
      }
    });
    this.postToNative({ type: WEBVIEW_GET_REFRESH_TOKEN });
    return promiseObj.promise();
  };

  openExternalLink = link => {
    this.postToNative({ type: WEBVIEW_OPEN_EXTERNAL_LINK, link });
  };

  copyToClipboard = text => {
    this.postToNative({ type: WEBVIEW_CLIPBOARD_WRITE, text });
  };

  ensureNoScroll = () => {
    this.postToNative({ type: WEBVIEW_ENSURE_SCROLL_STATE, value: false });
  };

  ensureScroll = () => {
    this.postToNative({ type: WEBVIEW_ENSURE_SCROLL_STATE, value: true });
  };

  requestAppReview = () => {
    this.postToNative({ type: WEBVIEW_APP_REVIEW });
  };

  openAppSettings = () => {
    this.postToNative({ type: WEBVIEW_OPEN_EXTERNAL_LINK, link: 'app-settings:' });
  };
}

export const nativeApi = new NativeAPI();


